import React, { useState } from 'react';
import { BlockWrapper } from '../../common/BlockWrapper';
import { hasChangesLiftsCranes } from '../../common/utils';
import LiftAndCranesApproval from './LiftAndCranesApproval';
import { RaisedButton } from 'material-ui';
import LiftAndCranesForm from './LiftAndCranesForm';
import LiftAndCranesView from './LiftAndCranesView';
import get from 'lodash/get';

const LiftsAndCranes = ({
    port,
    pendingChanges,
    onApproveField,
    onRejectField,
    updatePortField,
}) => {
    const [isEditing, setIsEditing] = useState(false);

    const saveChanges = async (change) => {
        updatePortField('liftsCranes', change, () => {
            setIsEditing(false);
        });
    };

    const processedStatus = get(pendingChanges, 'processedFields.liftsCranes.status');

    const isApproved = processedStatus === 'approved';
    const isRejected = processedStatus === 'rejected';

    if (
        !isApproved &&
        !isRejected &&
        hasChangesLiftsCranes(
            get(pendingChanges, 'originalValues.liftsCranes'), 
            get(pendingChanges, 'changedValues.liftsCranes'),
        )
    ) {
        return (
            <BlockWrapper title='Available Lift and Cranes'>
                <LiftAndCranesApproval 
                    originalValues={get(pendingChanges, 'originalValues.liftsCranes')}
                    changedValues={get(pendingChanges, 'changedValues.liftsCranes')}
                    onApprove={onApproveField}
                    onReject={onRejectField}
                />
            </BlockWrapper>
        );
    }

    return (
        <BlockWrapper title='Available Lift and Cranes'>
            {isEditing ? (
                <LiftAndCranesForm 
                    liftsCranes={port.liftsCranes}
                    onSubmit={values => saveChanges(values)}
                    onCancel={() => setIsEditing(false)}
                />
            ) : (
                <React.Fragment>
                    <LiftAndCranesView liftsCranes={port.liftsCranes} />
                    <div className='edit-actions'>
                        <RaisedButton
                            label='Edit Lift and Cranes'
                            onClick={() => setIsEditing(true)}
                            primary
                        />
                    </div>
                </React.Fragment>
            )}
        </BlockWrapper>
    );
};

LiftsAndCranes.proptypes = {

};

export default LiftsAndCranes;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranes.jsx